import { us } from './us';
import { ro } from './ro';

export const localesResources = {
  us: { translation: us },
  ro: { translation: ro }
};
